const storedClient = sessionStorage.getItem('dataClient')
const storedCartClient = sessionStorage.getItem('cartClient')

export const state = () => ({
  dataClient: storedClient ? JSON.parse(storedClient) : null,
  cartClient: storedCartClient ? JSON.parse(storedCartClient) : [],
})

export const getters = {
  allDataClient: (state) => state.dataClient || {},
  allCartClient: (state) => [...state.cartClient],
}

export const mutations = {
  SET_CLIENT(state, payload) {
    state.dataClient = payload
    sessionStorage.setItem('dataClient', JSON.stringify(state.dataClient))
  },
  CLEAN_CLIENT(state) {
    state.dataClient = []
    sessionStorage.removeItem('dataClient')
  },
  SET_CART_CLIENT(state, payload) {
    state.cartClient = payload
    sessionStorage.setItem('cartClient', JSON.stringify(state.cartClient))
  },
  CLEAN_CART_CLIENT(state, id) {
    state.cartClient = state.cartClient.filter((item) => item.id !== id)
    sessionStorage.setItem('cartClient', JSON.stringify(state.cartClient))
  },
  CLEAN_CART(state) {
    state.cartClient = []
    sessionStorage.removeItem('cartClient')
  },
  DECREASE_PRODUCT_QUANTITY(state, id) {
    const productIndex = state.cartClient.findIndex((item) => item.id === id)

    if (productIndex !== -1) {
      state.cartClient[productIndex].quantidade--

      if (state.cartClient[productIndex].quantidade === 0) {
        state.cartClient.splice(productIndex, 1)
      }

      sessionStorage.setItem('cartClient', JSON.stringify(state.cartClient))
    }
  },
}

export const actions = {
  adicionarClient({ commit }, payload) {
    const newData = { ...payload }
    commit('SET_CLIENT', newData)
  },
  cleanClient({ commit }, payload) {
    commit('CLEAN_CLIENT', payload)
  },

  adicionarCartClient({ commit }, payload) {
    const newCart = [...payload]
    commit('SET_CART_CLIENT', newCart)
  },
  cleanCartCient({ commit }, id) {
    commit('DECREASE_PRODUCT_QUANTITY', id)
  },
  fullyCleanCart({ commit }, payload) {
    commit('CLEAN_CART', payload)
  },
}
